import { multipart_headers } from "../state/helpers";
export const userService = {
  getUsers: (data) => window.axios.post("getUserList", data),
  getUserData: (data) => window.axios.post("getUser", data),
  deleteUser: (data) => window.axios.post("delete-user", data),
  blockById: (data) => window.axios.post("block-user-by-id", data),
  unblockById: (data) => window.axios.post("unblock-user-by-id", data),
  addUser:(data)=>window.axios.post("add", data, { headers: multipart_headers() }),
  updateUser: (data) =>
    window.axios.post("update", data, { headers: multipart_headers() }),
  getMonthWiseUserBooking: (data) =>
    window.axios.post("get-month-wise-user-booking", data),
  getMonthWiseUserEarning: (data) =>
    window.axios.post("get-month-wise-user-earning", data),
  getSetting: (data) => window.axios.post("get-settings", data),
};
